module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_7005.122b05ca.png";